import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';

import {ContactUsComponent} from './contact-us/contact-us.component';
import {ContactUsDirective} from './contact-us/contact-us.directive';
import {UISvgIconModule} from 'app/ui/svg-icon/svg-icon.module';
import {ZendeskComponent} from './zendesk/zendesk.component';
import { UIModule } from 'app/ui/ui.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UISvgIconModule,
        UIModule
    ],
    declarations: [
        ContactUsComponent,
        ContactUsDirective,
        ZendeskComponent
    ],
    entryComponents: [
        ContactUsComponent
    ],
    exports: [
        ContactUsComponent,
        ContactUsDirective,
        ZendeskComponent
    ]
})
export class FeedbackModule {
}
